import { InitPaymentAsync } from "../Services/PaymentService";

const endpoints = {
    products: {
        getAll: "api/Product/GetAll"
    },
    Attributes: {
        GetAllProductAttributesWithValues: "api/productattribute/GetAllProductAttributesWithValues"
    },
    User: {
        UserLogin: "api/users/UserLogin",
        VerifyUserOTP: "api/users/VerifyUserOTP",
        GetUserDetailsById: "api/users/GetById",
        UpdateUserDetails: "api/users/Update",
        SubmitContactDetails: "api/users/SendContactForm"
    },
    Cart: {
        AddToCart: "api/cart/AddToCart",
        GetCartItems: "api/cart/GetCartItems",
        RemoveCartItem: "api/cart/RemoveCartItem",
        UpdateCartItem: "api/cart/UpdateCartItem",
        MoveToCartOrWishlist: "api/cart/MoveToWishlistOrCart",
        MoveFromOrderToCart: "api/cart/MoveFromOrderToCart"
    },
    Orders: {
        GetAllOrders: "api/Order/GetAll",
        GenerateInvoice: "api/Order/GenerateInvoice",
        UpdateOrderStatus: "api/Order/UpdateStatus"
    },
    Address: {
        GetUserAddresses: "api/Address/GetByUserId",
        AddUserAddress: "api/Address/Create",
        UpdateUserAddress: "api/Address/Update",
        DeleteUserAddress: "api/Address/Delete",
        GetAllCities: "api/Address/GetAllCities"
    },
    ProductReview: {
        AddReviewOnProduct: "api/ProductReview/AddReviewOnProduct"
    },
    Payment: {
        InitPayment: "api/payment/init",
        VerifyPaymentAndCreateOrder: "api/payment/VerifyPayment",
        FetchSavedCards: "api/payment/FetchSavedCards",
        DeleteSavedToken: "api/payment/DeleteSavedToken",
        PaymentCOD: "api/payment/payment-cod"
    }
};

export default endpoints;